import { DatabaseMessage, Message, MessageUpdatePayload } from '@fake-stack-overflow/shared';
import { useEffect, useState } from 'react';
import { addMessage, getMessages } from '../services/messageService';
import useUserContext from './useUserContext';

const useMessagingPage = (type: 'game' | 'watch' | 'global', contextID?: string) => {
  const { user, socket } = useUserContext();
  const [messages, setMessages] = useState<DatabaseMessage[]>([]);
  const [newMessage, setNewMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchMessages = async () => {
      const msgs = await getMessages(type, contextID);
      setMessages(msgs);
    };

    fetchMessages();
  }, [type, contextID]);

  useEffect(() => {
    const handleMessageUpdate = (data: MessageUpdatePayload) => {
      if (data.msg.contextID === contextID && data.msg.type === type) {
        setMessages(prev => [...prev, data.msg]);
      }
    };

    socket.on('messageUpdate', handleMessageUpdate);
    return () => {
      socket.off('messageUpdate', handleMessageUpdate);
    };
  }, [socket, contextID, type]);

  const handleSendMessage = async () => {
    if (newMessage === '') {
      setError('Message cannot be empty');
      return;
    }

    setError('');
    const newMsg: Message = {
      msg: newMessage,
      msgFrom: user.username,
      msgDateTime: new Date(),
      type,
      contextID,
    };

    await addMessage(newMsg);
    setNewMessage('');
  };

  return { messages, newMessage, setNewMessage, handleSendMessage, error };
};

export default useMessagingPage;
